module.exports = __webpack_public_path__ + "assets/images/benches-0484fd0676dbfbc26cfdbdd7f878380f.jpg";